<template>
  <div>
    <div>
      <div :class="!showImportOrRegister ? 'homepage-wrapper justify-center' : ''">
        <v-row :class="!showImportOrRegister ? 'homepage-container m-0 p-0' : ''">
          <v-col cols="6" class="p-0" v-if="actualites.length > 0 && !isMobile && showLogin">
            <v-carousel :value="actualites[actualites.length-1]" :show-arrows="false" hide-delimiter-background cycle
                        class="carousel-container">
              <v-carousel-item v-for="(item, index) in actualites" :key="index" :src="item.image"
                               class="carousel-background">
                <div class="carousel-title p-12" v-html="item.title" @click="openLink(item)"></div>
              </v-carousel-item>
            </v-carousel>
          </v-col>

          <div class="d-flex col"
               :style="{
                  flexDirection: 'column',
                  width: '421px',
                  padding: showImportOrRegister ? '0' : '32px'
               }">
            <Transition>
              <div v-if="showLogin" class="container-connexion">
                <div class="login-container">
                  <login @ci98="showOnboarding"
                         @showRegister="toggleRegister"
                         @updateIdentifiant="updateIdentifiant"
                         :identifiantQuery="identifiantQuery"
                         :loginErrorDialog="loginErrorDialog">
                  </login>
                </div>
              </div>
            </Transition>

            <Transition>
              <div v-if="showImportOrRegister && !showImport" class="container-inscription">
                <div>
                  <SectionRegister :identifiant="identifiant"
                                   @toggleForm="toggleForm" />
                </div>
              </div>
            </Transition>

            <Transition>
              <div v-if="showImportOrRegister && showImport" class="container-inscription">
                <SectionOnboarding :code="onboardingCode"
                                   :identifiant="identifiant"
                                   @toggleForm="toggleForm"
                                   @completed="completeOnboarding" />
              </div>
            </Transition>

            <div v-if="!showImportOrRegister" class="homepage-toggle justify-center align-end d-flex">
              <loader-button :fullWidth="true" :outlined="true" :label="toggleFormBtnTxt"
                             @callback="toggleForm"></loader-button>

            </div>
          </div>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {isMobile} from '@/style/StyleHelpers';
import Login from '@/framework/connection/components/Login.vue';
import LoaderButton from '@/framework/base/components/LoaderButton.vue';
  import SectionRegister from "@/components/Register/SectionRegister.vue";
  import SectionOnboarding from "@/components/Onboarding/SectionOnboarding.vue";
import {FwkButtons, RessourceFwkButton} from '@/ressources/globalRessources';
import {isProduction} from '@/framework/base/helpers/Environment';
import Section from '@/framework/base/classes/Section';
import SectionContainer from '@/framework/base/components/SectionContainer.vue';
import Dialog from '@/generated/classes/Dialog';
import Actualite from '@/generated/classes/Actualite';
import {ListFilter} from '@/extend/classes/ListData';
import {defineComponent} from "vue";
import {useRoute, useRouter} from "vue-router";

export default defineComponent({
  components: {
    Login,
    LoaderButton,
    SectionContainer,
    SectionRegister,
    SectionOnboarding
  },
  data() {
    const actualites: Actualite[] = [];

    return {
      isMobile: isMobile(),
      isProduction: isProduction(),
      showLogin: true,
      showImportOrRegister: false,
      showImport: false,
      onboardingCode: '',
      identifiant: '',
      actualites,
      router: useRouter(),
      route: useRoute()
    };
  },
  computed: {    
    identifiantQuery(): string {
      let res = '';
      if (this.route.query != undefined && this.route.query.INSCRIPTION != undefined && this.route.query.INSCRIPTION == 'CI98') {
        this.toggleRegister();
      }
      if (this.route.query != undefined && this.route.query.ident != null) {
        res = this.route.query.ident as string;
      }
      return res;
    },
    toggleFormBtnTxt() {
      if (this.showLogin) return RessourceFwkButton(FwkButtons.REGISTER).label;
      else return RessourceFwkButton(FwkButtons.LOGIN).label;
    },
    identifiantIsNumber(): boolean {
      const regEx = /^[0-9][0-9 ]*$/;
      return regEx.test(this.identifiant);
    },
    loginErrorDialog(): Dialog {
      const dialog = new Dialog();
      dialog.buttons = [RessourceFwkButton(FwkButtons.LOGIN).label, RessourceFwkButton(FwkButtons.REGISTER).label];
      if (this.identifiantIsNumber) {
        dialog.label = "Le numéro <span class='error-text'><strong>" + this.identifiant + "</strong></span> est inconnu.<br>Vous pouvez vous inscrire avec ce numéro ou vous connecter avec un autre identifiant."
      } else {
        dialog.label = "L'adresse mail <span class='error-text'><strong>" + this.identifiant + "</strong></span> est inconnue.<br>Vous pouvez vous inscrire avec cette adresse ou vous connecter avec un autre identifiant."
      }
      return dialog;
    }
  },
  created() {
    Actualite.list(new ListFilter()).then((items) => {
      items.reccords.forEach((item) => {
        this.actualites.push(item as Actualite);
      });
    }).catch((err) => {
      console.log(err)
    });
  },
  methods: {
    showOnboarding(code: string) {
      this.onboardingCode = code;
      this.showImport = true;
      this.showLogin = false;
      setTimeout(() => {
        this.showImportOrRegister = true;
        this.router.push({name: 'HomePage', query: {key: 'onboarding'}});
      }, 400);
    },
    updateIdentifiant(value: string) {
      this.identifiant = value;
    },
    toggleRegister() {
      if (this.showLogin) {
        this.showImport = false;
        this.showLogin = false;
        setTimeout(() => {
          this.showImportOrRegister = true;
          this.router.push({name: 'HomePage', query: {key: 'subscribe'}});
        }, 400);
      }
    },
    toggleForm() {
      if (this.showLogin) {
        this.showImport = false;
        this.showLogin = false;
        setTimeout(() => {
          this.identifiant = '';
          this.showImportOrRegister = true;
          this.router.push({name: 'HomePage', query: {key: 'subscribe'}});
        }, 400);
      } else {
        this.showImportOrRegister = false;
        this.showImport = false;
        this.onboardingCode = '';
        setTimeout(() => {
          this.showLogin = true;
          this.router.push({name: 'HomePage', query: {key: 'login'}});
        }, 400);
      }
    },
    completeOnboarding() {
      this.showImportOrRegister = false;
      this.showImport = false;
      this.showLogin = true;
      this.onboardingCode = '';
      this.$router.push({name: 'HomePage', query: {key: 'login'}});
    },
    openLink(actualite: Actualite) {
      if (actualite.url) {
        window.open(actualite.url, '_blank');
      }
    }
  }
})


</script>

<style scoped>
.v-enter-active,
.v-leave-active {
  transition: opacity 0.3s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
